export enum NavigationAction {
  CLOSE,
  HISTORY_BACK,
}
